import React, { useRef } from 'react';

import { Box } from '@mui/material';

import { useGetSearchTerm } from '../../../shared/hooks/use-get-search-term/use-get-search-term.hook';
import { WEB_GAMES } from '../../../store/utils/files-names';
import SearchBar from '../../shared/components/search-bar/SearchBar';
import { useClearText } from '../../shared/components/search-bar/hooks/use-clear-text/use-clear-text.hook';
import SetIsCheckedContextProvider from '../../shared/components/ui/Table/components/table/context/set-is-checked/set-is-checked.context';
import { useInputHandlerEvent } from '../../shared/hooks/use-input-event-handler/use-input-event-handler.hook';
import { useSearchHandlerEvent } from '../../shared/hooks/use-search-event-handler/use-search-event-handler.hook';
import { filterGamesByTitle } from '../store/slices/web-game.slice';
import { getWebGames } from '../thunks/get-web-games.thunk';
import { WebGamesFiltersModel } from '../thunks/models/web-games-filters.model';
import { WebGamesTable } from './web-games-table/web-games-table';

export const WebGames = () => {
  const gamesSearchTerm = useGetSearchTerm(WEB_GAMES, 'title');
  const inputRef = useRef<HTMLInputElement>(null);
  const clearText = useClearText(inputRef, filterGamesByTitle, 'title');

  const handleInputEvent = useInputHandlerEvent<WebGamesFiltersModel>(
    'title',
    filterGamesByTitle
  );

  const handleSearchEvent = useSearchHandlerEvent(getWebGames, WEB_GAMES);

  return (
    <Box>
      <SetIsCheckedContextProvider>
        <SearchBar
          createRoutePath="/game-center-management/create"
          searchInputPlaceholder="Title"
          searchInputChangeHandler={handleInputEvent}
          searchOnSubmitHandler={handleSearchEvent}
          inputRef={inputRef}
          clearText={clearText}
          initialValue={gamesSearchTerm}
        />
        <WebGamesTable />
      </SetIsCheckedContextProvider>
    </Box>
  );
};
